import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Icon from '../../../modules/react/components/stateless/Icon';
import styles from './styles.scss';

const propTypes = {
  page: PropTypes.shape({
    live: PropTypes.bool.isRequired,
  }).isRequired,
};
const defaultProps = {};

const PageStatusIcon = ({ page }) => (
  <Icon
    id={page.live ? 'success' : 'draft'}
    context={page.live ? 'positive' : 'secondary'}
    className={styles.icon}
    label="page status"
  />
);

PageStatusIcon.propTypes = propTypes;
PageStatusIcon.defaultProps = defaultProps;

PageStatusIcon.fragments = {
  page: gql`
    fragment PageStatusIconPage on Page {
      live
    }
  `,
};

export default PageStatusIcon;
